import { FC, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

interface ScrollToTopProps {
  history: any
}

const ScrollToTop: FC<ScrollToTopProps> = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0)
    })
    return () => {
      unlisten()
    }
  }, [history])

  return null
}

export default withRouter(ScrollToTop)
